import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { 
  HiOutlineUser, 
  HiOutlineLogout,
  HiOutlineViewGrid
} from 'react-icons/hi';
import { USER_TYPES, getUserTypeLabel, getUserIcon } from '../../../config/userTypes';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { getAuthType, isAuthenticated } = useAuth();
  const userType = getAuthType();
  const userTypeConfig = USER_TYPES[userType?.toUpperCase?.()] || null;
  const userIcon = getUserIcon(userType);

  const handleLogout = () => {
    // 認証情報を完全に削除
    localStorage.removeItem('tokens');
    localStorage.removeItem('authType');

    // 必要なら状態管理のlogoutも呼ぶ
    // logout(); ← useAuth() から取得している場合はこれも呼ぶと良い

    // サインインページへ遷移
    window.location.href = '/signin';
  };

  const handleDashboard = () => {
    if (userTypeConfig) {
      navigate(userTypeConfig.dashboardPath);
    }
    setIsOpen(false);
  };

  const menuItems = [
    { 
      icon: HiOutlineViewGrid, 
      label: 'ダッシュボード', 
      action: handleDashboard
    },
    { 
      icon: HiOutlineLogout, 
      label: 'ログアウト', 
      action: handleLogout
    }
  ];

  return (
    <div className="relative">
      {isAuthenticated ? (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-1 sm:space-x-2 p-1 sm:p-2 rounded-lg 
            bg-blue-100 hover:bg-blue-200  /* より濃い青色に変更 */
            dark:bg-gray-700 dark:hover:bg-gray-600  /* ダークモード時の背景色 */
            transition-colors duration-200
            min-w-0" /* 最小幅を0にしてフレックスアイテムが縮小できるようにする */
        >
          <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden flex-shrink-0">
            {userIcon ? (
              <img 
                src={userIcon} 
                alt={getUserTypeLabel(userType)}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.onerror = null; // 無限ループ防止
                  e.target.src = ''; // 画像読み込みエラー時にデフォルトアイコンを表示
                  e.target.parentElement.innerHTML = 
                    '<svg class="w-3 h-3 sm:w-5 sm:h-5 text-gray-600" ... >...</svg>';
                }}
              />
            ) : (
              <HiOutlineUser className="w-3 h-3 sm:w-5 sm:h-5 text-gray-600" />
            )}
          </div>
          <span className="text-gray-800 dark:text-white text-xs sm:text-sm truncate max-w-24 sm:max-w-32 md:max-w-none">
            {getUserTypeLabel(userType)}
          </span>
        </button>
      ) : (
        <button
          onClick={() => window.location.href = '/signin'}
          className="flex items-center space-x-1 sm:space-x-2 p-1 sm:p-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white transition-colors duration-200"
        >
          <HiOutlineUser className="w-3 h-3 sm:w-5 sm:h-5" />
          <span className="text-xs sm:text-sm">ログイン</span>
        </button>
      )}

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 sm:w-56 rounded-lg shadow-lg py-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 z-50">
          <div className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700 truncate">
            {getUserTypeLabel(userType)}
          </div>
          
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserMenu; 